import { captureMessage, captureException } from '@sentry/browser'

import { env } from 'src/config/env'

const isDev = env.MODE !== 'prod'

const stringifyArgs = (args: any[]): string => {
  return args
    .map((arg) => {
      if (typeof arg === 'object' && arg !== null) {
        return JSON.stringify(arg, null, 2)
      }
      return String(arg)
    })
    .join(' ')
}

export const logger = {
  debug: (...args: any[]) => {
    if (isDev) {
      console.log(...args)
    }
  },
  warn: (...args: any[]) => {
    console.warn(...args)
    if (!isDev) {
      captureMessage(stringifyArgs(args), {
        level: 'warning',
      })
    }
  },
  error: (...args: any[]) => {
    console.error(...args)
    if (!isDev) {
      const firstArg = args[0]
      const error = firstArg instanceof Error ? firstArg : new Error(stringifyArgs(args))

      // Capture remaining arguments as extra context
      const extraContext = args.slice(1).reduce(
        (acc, arg, index) => ({
          ...acc,
          [`arg${index + 1}`]: typeof arg === 'object' ? JSON.stringify(arg) : String(arg),
        }),
        {},
      )

      captureException(error, {
        level: 'error',
        extra: extraContext,
      })
    }
  },
}
